import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

interface PrivateRouteProps {
  element: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { token, isRefreshing } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isRefreshing) {
      setLoading(false);
    } else if (token !== '') {
      setLoading(false);
    }
  }, [token, isRefreshing]);

  if (!token && (loading || isRefreshing)) {
    return <div>Loading...</div>;
  }

  return token ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
